import { combineReducers } from "redux";
import { configureStore } from "@reduxjs/toolkit";
import getAllHomeSectionsSlice from "../Slices/website/home/getAllHomeSections";
import getAllstakeNowSectionsSlice from "../Slices/website/stakeNow/getAllstakeNowSections";
import getAllReferralsSectionsSlice from "../Slices/website/referrals/getAllReferralsSections";
import getAllBlogSectionsSlice from "../Slices/website/blog/getAllBlogSections";
import getAllContactUsSectionsSlice from "../Slices/website/contactUs/getAllContactUsSections";
import getAllAboutUsSectionsSlice from "../Slices/website/AboutUs/getAllAboutUsSections";
import postContactUsFormSlice from "../Slices/website/contactUs/postContactUsForm";
import cartSlice from "../Slices/AddToCard/cartSlice";
import customerRegisterSlice from "../Slices/Customer/customerRegister";
import customerLoginSlice from "../Slices/Customer/customerLogin";
import PurchaseSchemesSlice from "../Slices/Schemes/PurchaseSchemes";
import ImageUploadPostSlice from "../Slices/Customer/ImageUploadPost";
import getKYCByCountrySlice from "../Slices/Customer/getKYCByCountry";
import getCustomerGoldBalanceDashboardSlice from "../Slices/Customer/getCustomerGoldBalanceDashboard";
import getPurchasesByCustomerIdSlice from "../Slices/Customer/getPurchasesByCustomerId";
import getCustomerRewardsListSlice from "../Slices/Customer/getCustomerRewardsList";
import getReferralRewardDashboardSlice from "../Slices/Customer/getReferralRewardDashboard";
import getCartItemCountSlice from "../Slices/AddToCard/getCartItemCount";
import EmailSendOtpSlice from "../Slices/VerificationOtp/EmailSendOtp";
import EmailVerifyOtpSlice from "../Slices/VerificationOtp/EmailVerifyOtp";
import addMultiPurchaseSlice from "../Slices/Customer/addMultiPurchase";
import resetPasswordForCustomerSlice from "../Slices/VerificationOtp/resetPasswordForCustomer";
import getPlanByIdSlice from "../Slices/AddToCard/getPlanById";
import authReducer from "../Slices/authSlice";
import headerReducer from "../Slices/headerSlice";
import managementRegisterForCustomerSlice from "../Slices/Operator/managementRegisterForCustomer";
import loginOperatorSlice from "../Slices/Operator/loginOperator";
import getCustomersByCreatorSlice from "../Slices/Operator/getCustomersByCreator";
import getAllActivePlansSlice from "../Slices/Operator/getAllActivePlans";
import getOperatorDashboardMetricsSlice from "../Slices/Operator/getOperatorDashboardMetrics";
import getCartItemsSlice from "../Slices/AddToCard/getCartItems";
import decrementQuantitySlice from "../Slices/AddToCard/decrementQuantity";
import incrementQuantitySlice from "../Slices/AddToCard/incrementQuantity";
import customerReducer from "../Slices/Operator/customerSlice";
import clearCartSlice from "../Slices/AddToCard/clearCart";
import uploadPdfAndImageSlice from "../Slices/Customer/uploadPdfAndImage";
import getPurchasesByCreatorSlice from "../Slices/Operator/getPurchasesByCreator";
import getCashPurchasesByCreatorSlice from "../Slices/Operator/getCashPurchasesByCreator";
import getAllCustomersStatusSlice from "../Slices/AuthUser/getAllCustomersStatus"
import getCustomerByIdSlice from "../Slices/AuthUser/getCustomerById"
import approveCustomerSlice from "../Slices/AuthUser/approveCustomer"
import checkCustomerExistForEmailRegisterSlice from '../Slices/Customer/checkCustomerExistForEmailRegister';
import checkCustomerExistPhoneForRegisterSlice from '../Slices/Customer/checkCustomerExistPhoneForRegister';
import getAllUserWithRoleSlice from '../Slices/AuthUser/getAllUserWithRole'
import multiUserCreationSlice from "../Slices/AuthUser/multiUserCreation"
import getNetBankingPurchasesByCreatorSlice from "../Slices/Operator/getNetBankingPurchasesByCreator"
import buttonReducer from '../Slices/Operator/buttonSlice';
import addPlanPostSlice from "../Slices/Schemes/addPlanPost";
import getAllPlansGetSlice from "../Slices/Schemes/getAllPlansGet";
import getAllFinanceConsultantListForAuthUserSlice from "../Slices/Operator/getAllFinanceConsultantListForAuthUser";
import getAllCustomerRewardsListForAuthUserSlice from "../Slices/Operator/getAllCustomerRewardsListForAuthUser";
import getAllPurchasesListForAuthUserSlice from '../Slices/Operator/getAllPurchasesListForAuthUser'
import getAllTiersSlice from '../Slices/Tiers/getAllTiers'
import createTierSlice from '../Slices/Tiers/createTier'
import getAllRolesWithModulesSlice from '../Slices/userRole/getAllRolesWithModules'
import createRoleWithPermissionsSlice from '../Slices/userRole/createRoleWithPermissions'
import getAllRolesSlice from '../Slices/userRole/getAllRoles'
import getPurchaseByIdSlice from "../Slices/Operator/getPurchaseById";
import TableIdGetReducer from "../Slices/TableId/TableIdGetSlice"
import updatePlanPutSlice from "../Slices/Schemes/updatePlanPut";
import getPermissionsForAuthUserSlice from "../Slices/userRole/getPermissionsForAuthUser";
import updateAllPermissionsForAuthUserSlice from "../Slices/userRole/updateAllPermissionsForAuthUser";
import getReferrerCustomerRewardsByCustomerIdSlice from '../Slices/Operator/getReferrerCustomerRewardsByCustomerId'
import activateLastTierSlice from '../Slices/Tiers/activateLastTier'
import inactivateLastTierSlice from '../Slices/Tiers/inactivateLastTier'
import getAuthUserByIdSlice from "../Slices/AuthUser/getAuthUserById"
import updateAuthUserSlice from "../Slices/AuthUser/updateAuthUser"
import softDeleteAuthUserSlice from "../Slices/AuthUser/softDeleteAuthUser";
import updateTierSlice from "../Slices/Tiers/updateTier"
import getTierByIdSlice from "../Slices/Tiers/getTierById"
import deletePlanSlice from "../Slices/Schemes/deletePlan";
import addHomeSectionPostSlice from "../Slices/ContentManagement/HomeSection/addHomeSectionPost";
import addStakeNowSectionPostSlice from "../Slices/ContentManagement/StakeNowSection/addStakeNowSection";
import getStakeNowSectionByIdSlice from "../Slices/ContentManagement/StakeNowSection/getStakeNowSectionById";
import updateStakeNowSectionSlice from "../Slices/ContentManagement/StakeNowSection/updateStakeNowSection";
import getAllCountryNamesSlice from '../Slices/Customer/getAllCountryNames';
import getAllCitiesByStateSlice from '../Slices/Customer/getAllCitiesByState';
import getAllStatesByCountrySlice from '../Slices/Customer/getAllStatesByCountry';
import deleteStakeNowSectionSlice from "../Slices/ContentManagement/StakeNowSection/deleteStakeNowSection";
import AddCityPostSlice from "../Slices/Country/AddCityPost";
import AddCountryPostSlice from "../Slices/Country/AddCountryPost";
import AddStatePostSlice from "../Slices/Country/AddStatePost";
import getCountryByIdSlice from "../Slices/Country/getCountryById";
import getAllHomeSectionsWithCreatorBySectionNameSlice from "../Slices/ContentManagement/HomeSection/getAllHomeSectionsWithCreatorBySectionName";
import getAllHomeSectionsBySectionNameBasedOnCreatorSlice from "../Slices/ContentManagement/HomeSection/getAllHomeSectionsBySectionNameBasedOnCreator";
import addHomeSectionWithApprovalSlice from "../Slices/ContentManagement/HomeSection/addHomeSectionWithApproval";
import updateHomeSectionForReApprovalSlice from "../Slices/ContentManagement/HomeSection/updateHomeSectionForReApproval";
import updateHomeSectionSlice from "../Slices/ContentManagement/HomeSection/updateHomeSection";
import getHomeSectionByIdSlice from "../Slices/ContentManagement/HomeSection/getHomeSectionById";
import deleteHomeSectionSlice from "../Slices/ContentManagement/HomeSection/deleteHomeSection";
import addStakeNowSectionWithApprovalSlice from "../Slices/ContentManagement/StakeNowSection/addStakeNowSectionWithApproval";
import getAllStakeNowSectionsWithCreatorBySectionNameSlice from "../Slices/ContentManagement/StakeNowSection/getAllStakeNowSectionsWithCreatorBySectionName";
import getAllStakeNowSectionsBySectionNameBasedOnCreatorSlice from "../Slices/ContentManagement/StakeNowSection/getAllStakeNowSectionsBySectionNameBasedOnCreator";
import updateStakeNowSectionForReApprovalSlice from "../Slices/ContentManagement/StakeNowSection/updateStakeNowSectionForReApproval";
import addMultipleKYCsSlice from "../Slices/Country/addMultipleKYCs";
import addReferralSectionSlice from "../Slices/ContentManagement/ReferralsSection/addReferralSection";
import addReferralSectionWithApprovalSlice from "../Slices/ContentManagement/ReferralsSection/addReferralSectionWithApproval";
import deleteReferralSectionSlice from "../Slices/ContentManagement/ReferralsSection/deleteReferralSection";
import getAllReferralSectionsBySectionNameBasedOnCreatorSlice from "../Slices/ContentManagement/ReferralsSection/getAllReferralSectionsBySectionNameBasedOnCreator";
import getAllReferralSectionsWithCreatorBySectionNameSlice from "../Slices/ContentManagement/ReferralsSection/getAllReferralSectionsWithCreatorBySectionName";
import getReferralSectionByIdSlice from "../Slices/ContentManagement/ReferralsSection/getReferralSectionById";
import updateReferralSectionSlice from "../Slices/ContentManagement/ReferralsSection/updateReferralSection";
import updateReferralSectionForReApprovalSlice from "../Slices/ContentManagement/ReferralsSection/updateReferralSectionForReApproval";
import addAboutUsSectionSlice from "../Slices/ContentManagement/AboutUsSection/addAboutUsSection";
import addAboutUsSectionWithApprovalSlice from "../Slices/ContentManagement/AboutUsSection/addAboutUsSectionWithApproval";
import deleteAboutUsSectionSlice from "../Slices/ContentManagement/AboutUsSection/deleteAboutUsSection";
import getAllAboutUsSectionsBySectionNameBasedOnCreatorSlice from "../Slices/ContentManagement/AboutUsSection/getAllAboutUsSectionsBySectionNameBasedOnCreator";
import getAllAboutUsSectionsWithCreatorBySectionNameSlice from "../Slices/ContentManagement/AboutUsSection/getAllAboutUsSectionsWithCreatorBySectionName";
import getAboutUsSectionByIdSlice from "../Slices/ContentManagement/AboutUsSection/getAboutUsSectionById";
import updateAboutUsSectionSlice from "../Slices/ContentManagement/AboutUsSection/updateAboutUsSection";
import updateAboutUsSectionForReApprovalSlice from "../Slices/ContentManagement/AboutUsSection/updateAboutUsSectionForReApproval";
import addBlogSectionSlice from "../Slices/ContentManagement/BlogSection/addBlogSection";
import addBlogSectionWithApprovalSlice from "../Slices/ContentManagement/BlogSection/addBlogSectionWithApproval";
import deleteBlogSectionSlice from "../Slices/ContentManagement/BlogSection/deleteBlogSection";
import getBlogSectionByIdSlice from "../Slices/ContentManagement/BlogSection/getBlogSectionById";
import getAllBlogSectionsBySectionNameBasedOnCreatorSlice from "../Slices/ContentManagement/BlogSection/getAllBlogSectionsBySectionNameBasedOnCreator";
import getAllBlogSectionsWithCreatorBySectionNameSlice from "../Slices/ContentManagement/BlogSection/getAllBlogSectionsWithCreatorBySectionName";
import updateBlogSectionSlice from "../Slices/ContentManagement/BlogSection/updateBlogSection";
import updateBlogSectionForReApprovalSlice from "../Slices/ContentManagement/BlogSection/updateBlogSectionForReApproval";
import addContactUsSectionSlice from "../Slices/ContentManagement/ContactUsSection/addContactUsSection";
import addContactUsSectionWithApprovalSlice from "../Slices/ContentManagement/ContactUsSection/addContactUsSectionWithApproval";
import deleteContactUsSectionSlice from "../Slices/ContentManagement/ContactUsSection/deleteContactUsSection";
import getContactUsSectionByIdSlice from "../Slices/ContentManagement/ContactUsSection/getContactUsSectionById";
import getAllContactUsSectionsBySectionNameBasedOnCreatorSlice from "../Slices/ContentManagement/ContactUsSection/getAllContactUsSectionsBySectionNameBasedOnCreator";
import getAllContactUsSectionsWithCreatorBySectionNameSlice from "../Slices/ContentManagement/ContactUsSection/getAllContactUsSectionsWithCreatorBySectionName";
import updateContactUsSectionSlice from "../Slices/ContentManagement/ContactUsSection/updateContactUsSection";
import updateContactUsSectionForReApprovalSlice from "../Slices/ContentManagement/ContactUsSection/updateContactUsSectionForReApproval";
import getAllPendingCustomersWithCreatorSlice from "../Slices/Approvals/RegistrationApprovals/getAllPendingCustomersWithCreator";
import getAllApprovedCustomersWithCreatorAndApproverSlice from "../Slices/Approvals/RegistrationApprovals/getAllApprovedCustomersWithCreatorAndApprover";
import rejectCustomerSlice from "../Slices/Approvals/RegistrationApprovals/rejectCustomer";
import getAllRejectedCustomersWithCreatorAndRejectorSlice from "../Slices/Approvals/RegistrationApprovals/getAllRejectedCustomersWithCreatorAndRejector";
import getAllReapprovalCustomersWithCreatorAndRejectorSlice from "../Slices/Approvals/RegistrationApprovals/getAllReapprovalCustomersWithCreatorAndRejector";
import getAllHomeSectionsBySectionNameSlice from "../Slices/ContentManagement/HomeSection/getAllHomeSectionsBySectionName";
import rejectHomeSectionSlice from "../Slices/ContentManagement/HomeSection/rejectHomeSection";
import approveHomeSectionSlice from "../Slices/ContentManagement/HomeSection/approveHomeSection";
import approveStakeNowSectionSlice from "../Slices/ContentManagement/StakeNowSection/approveStakeNowSection";
import rejectStakeNowSectionSlice from "../Slices/ContentManagement/StakeNowSection/rejectStakeNowSection";
import approveReferralSectionSlice from "../Slices/ContentManagement/ReferralsSection/approveReferralSection";
import rejectReferralSectionSlice from "../Slices/ContentManagement/ReferralsSection/rejectStakeNowSection";
import approveAboutUsSectionSlice from "../Slices/ContentManagement/AboutUsSection/approveAboutUsSection";
import rejectAboutUsSectionSlice from "../Slices/ContentManagement/AboutUsSection/rejectAboutUsSection";
import approveBlogSectionSlice from "../Slices/ContentManagement/BlogSection/approveBlogSection";
import rejectBlogSectionSlice from "../Slices/ContentManagement/BlogSection/rejectBlogSection";
import rejectContactUsSectionSlice from "../Slices/ContentManagement/ContactUsSection/rejectContactUsSection";
import approveContactUsSectionSlice from "../Slices/ContentManagement/ContactUsSection/approveContactUsSection";

import getAllPendingPlansWithCreatorSlice from "../Slices/Management/getAllPendingPlansWithCreator"
import getAllApprovedPlansWithCreatorAndApproverSlice from "../Slices/Management/getAllApprovedPlansWithCreatorAndApprover"
import getAllRejectedPlansWithCreatorAndRejectorSlice from '../Slices/Management/getAllRejectedPlansWithCreatorAndRejector'
import getAllReapprovalPlansWithCreatorAndRejectorSlice from '../Slices/Management/getAllReapprovalPlansWithCreatorAndRejector'
import approvePlanSlice from '../Slices/Management/approvePlan'
import rejectPlanSlice from '../Slices/Management/rejectPlan'
import getAllPendingPurchasesWithCreatorSlice from '../Slices/Management/getAllPendingPurchasesWithCreator'
import getAllApprovedPurchasesWithCreatorAndApproverSlice from '../Slices/Management/getAllApprovedPurchasesWithCreatorAndApprover'
import approvePurchaseSlice from '../Slices/Management/approvePurchase'
import getAllActiveTiersSlice from "../Slices/Tiers/getAllActiveTiers";
import getAllCountriesWithDetailsSlice from "../Slices/Country/getAllCountriesWithDetails";
import getCountryWithDetailsByIdSlice from "../Slices/Country/getCountryWithDetailsById";
import addPlanWithApprovalSlice from "../Slices/Schemes/addPlanWithApproval";
import updatePlanForReApprovalSlice from "../Slices/Schemes/updatePlanForReApproval";
import getAllPlansWithCreatorSlice from "../Slices/Schemes/getAllPlansWithCreator";
import getAllPlansBasedOnCreatorSlice from "../Slices/Schemes/getAllPlansBasedOnCreator";
import getManagementDashboardDataSlice from "../Slices/Dashboard/getManagementDashboardData";



const reducer = combineReducers({
  getAllHomeSections: getAllHomeSectionsSlice,
  getAllstakeNowSections: getAllstakeNowSectionsSlice,
  getAllReferralsSections: getAllReferralsSectionsSlice,
  getAllBlogSections: getAllBlogSectionsSlice,
  getAllContactUsSections: getAllContactUsSectionsSlice,
  getAllAboutUsSections: getAllAboutUsSectionsSlice,
  postContactUsForm: postContactUsFormSlice,
  cart: cartSlice,
  getCartItems: getCartItemsSlice,
  customerRegister: customerRegisterSlice,
  customerLogin: customerLoginSlice,
  PurchaseSchemes: PurchaseSchemesSlice,
  ImageUploadPost: ImageUploadPostSlice,
  getKYCByCountry: getKYCByCountrySlice,
  getCustomerGoldBalanceDashboard: getCustomerGoldBalanceDashboardSlice,
  getPurchasesByCustomerId: getPurchasesByCustomerIdSlice,
  getCustomerRewardsList: getCustomerRewardsListSlice,
  getReferralRewardDashboard: getReferralRewardDashboardSlice,
  getCartItemCount: getCartItemCountSlice,
  EmailSendOtp: EmailSendOtpSlice,
  EmailVerifyOtp: EmailVerifyOtpSlice,
  addMultiPurchase: addMultiPurchaseSlice,
  resetPasswordForCustomer: resetPasswordForCustomerSlice,
  getPlanById: getPlanByIdSlice,
  auth: authReducer,
  header: headerReducer,
  managementRegisterForCustomer: managementRegisterForCustomerSlice,
  loginOperator: loginOperatorSlice,
  getCustomersByCreator: getCustomersByCreatorSlice,
  getAllActivePlans: getAllActivePlansSlice,
  getOperatorDashboardMetrics: getOperatorDashboardMetricsSlice,
  decrementQuantity: decrementQuantitySlice,
  incrementQuantity: incrementQuantitySlice,
  customer: customerReducer,
  clearCart: clearCartSlice,
  uploadPdfAndImage: uploadPdfAndImageSlice,
  getPurchasesByCreator: getPurchasesByCreatorSlice,
  getCashPurchasesByCreator: getCashPurchasesByCreatorSlice,
  getAllCustomersStatus: getAllCustomersStatusSlice,
  getCustomerById: getCustomerByIdSlice,
  approveCustomer: approveCustomerSlice,
  checkCustomerExistForEmailRegister: checkCustomerExistForEmailRegisterSlice,
  checkCustomerExistPhoneForRegister: checkCustomerExistPhoneForRegisterSlice,
  getAllUserWithRole: getAllUserWithRoleSlice,
  multiUserCreation: multiUserCreationSlice,
  getNetBankingPurchasesByCreator: getNetBankingPurchasesByCreatorSlice,
  button: buttonReducer,
  addPlanPost: addPlanPostSlice,
  getAllPlansGet: getAllPlansGetSlice,
  getAllFinanceConsultantListForAuthUser: getAllFinanceConsultantListForAuthUserSlice,
  getAllCustomerRewardsListForAuthUser: getAllCustomerRewardsListForAuthUserSlice,
  getAllPurchasesListForAuthUser: getAllPurchasesListForAuthUserSlice,
  getAllTiers: getAllTiersSlice,
  createTier: createTierSlice,
  getAllRolesWithModules: getAllRolesWithModulesSlice,
  createRoleWithPermissions: createRoleWithPermissionsSlice,
  getAllRoles: getAllRolesSlice,
  getPurchaseById: getPurchaseByIdSlice,
  Table: TableIdGetReducer,
  updatePlanPut: updatePlanPutSlice,
  getPermissionsForAuthUser: getPermissionsForAuthUserSlice,
  updateAllPermissionsForAuthUser: updateAllPermissionsForAuthUserSlice,
  getReferrerCustomerRewardsByCustomerId: getReferrerCustomerRewardsByCustomerIdSlice,
  activateLastTier: activateLastTierSlice,
  inactivateLastTier: inactivateLastTierSlice,
  getAuthUserById: getAuthUserByIdSlice,
  updateAuthUser: updateAuthUserSlice,
  softDeleteAuthUser: softDeleteAuthUserSlice,

  updateTier: updateTierSlice,
  getTierById: getTierByIdSlice,
  deletePlan: deletePlanSlice,
  addHomeSectionPost: addHomeSectionPostSlice,
  addStakeNowSectionPost: addStakeNowSectionPostSlice,
  getStakeNowSectionById: getStakeNowSectionByIdSlice,
  updateStakeNowSection: updateStakeNowSectionSlice,
  getAllCountryNames: getAllCountryNamesSlice,
  getAllCitiesByState: getAllCitiesByStateSlice,
  getAllStatesByCountry: getAllStatesByCountrySlice,
  deleteStakeNowSection: deleteStakeNowSectionSlice,
  AddCityPost: AddCityPostSlice,
  AddCountryPost: AddCountryPostSlice,
  AddStatePost: AddStatePostSlice,
  getCountryById: getCountryByIdSlice,
  getAllHomeSectionsWithCreatorBySectionName: getAllHomeSectionsWithCreatorBySectionNameSlice,
  getAllHomeSectionsBySectionNameBasedOnCreator: getAllHomeSectionsBySectionNameBasedOnCreatorSlice,
  addHomeSectionWithApproval: addHomeSectionWithApprovalSlice,
  updateHomeSectionForReApproval: updateHomeSectionForReApprovalSlice,
  updateHomeSection: updateHomeSectionSlice,
  getHomeSectionById: getHomeSectionByIdSlice,
  deleteHomeSection: deleteHomeSectionSlice,
  addStakeNowSectionWithApproval: addStakeNowSectionWithApprovalSlice,
  getAllStakeNowSectionsWithCreatorBySectionName: getAllStakeNowSectionsWithCreatorBySectionNameSlice,
  getAllStakeNowSectionsBySectionNameBasedOnCreator: getAllStakeNowSectionsBySectionNameBasedOnCreatorSlice,
  updateStakeNowSectionForReApproval: updateStakeNowSectionForReApprovalSlice,
  addMultipleKYCs: addMultipleKYCsSlice,
  addReferralSection: addReferralSectionSlice,
  addReferralSectionWithApproval: addReferralSectionWithApprovalSlice,
  deleteReferralSection: deleteReferralSectionSlice,
  getAllReferralSectionsBySectionNameBasedOnCreator: getAllReferralSectionsBySectionNameBasedOnCreatorSlice,
  getAllReferralSectionsWithCreatorBySectionName: getAllReferralSectionsWithCreatorBySectionNameSlice,
  getReferralSectionById: getReferralSectionByIdSlice,
  updateReferralSection: updateReferralSectionSlice,
  updateReferralSectionForReApproval: updateReferralSectionForReApprovalSlice,
  addAboutUsSection: addAboutUsSectionSlice,
  addAboutUsSectionWithApproval: addAboutUsSectionWithApprovalSlice,
  deleteAboutUsSection: deleteAboutUsSectionSlice,
  getAllAboutUsSectionsBySectionNameBasedOnCreator: getAllAboutUsSectionsBySectionNameBasedOnCreatorSlice,

  getAllAboutUsSectionsWithCreatorBySectionName: getAllAboutUsSectionsWithCreatorBySectionNameSlice,
  getAboutUsSectionById: getAboutUsSectionByIdSlice,
  updateAboutUsSection: updateAboutUsSectionSlice,
  updateAboutUsSectionForReApproval: updateAboutUsSectionForReApprovalSlice,
  addBlogSection: addBlogSectionSlice,
  addBlogSectionWithApproval: addBlogSectionWithApprovalSlice,
  deleteBlogSection: deleteBlogSectionSlice,
  getBlogSectionById: getBlogSectionByIdSlice,
  getAllBlogSectionsBySectionNameBasedOnCreator: getAllBlogSectionsBySectionNameBasedOnCreatorSlice,
  getAllBlogSectionsWithCreatorBySectionName: getAllBlogSectionsWithCreatorBySectionNameSlice,
  updateBlogSection: updateBlogSectionSlice,
  updateBlogSectionForReApproval: updateBlogSectionForReApprovalSlice,
  addContactUsSection: addContactUsSectionSlice,
  addContactUsSectionWithApproval: addContactUsSectionWithApprovalSlice,
  deleteContactUsSection: deleteContactUsSectionSlice,
  getContactUsSectionById: getContactUsSectionByIdSlice,
  getAllContactUsSectionsBySectionNameBasedOnCreator: getAllContactUsSectionsBySectionNameBasedOnCreatorSlice,
  getAllContactUsSectionsWithCreatorBySectionName: getAllContactUsSectionsWithCreatorBySectionNameSlice,
  updateContactUsSection: updateContactUsSectionSlice,
  updateContactUsSectionForReApproval: updateContactUsSectionForReApprovalSlice,
  getAllPendingCustomersWithCreator: getAllPendingCustomersWithCreatorSlice,
  getAllApprovedCustomersWithCreatorAndApprover: getAllApprovedCustomersWithCreatorAndApproverSlice,
  rejectCustomer: rejectCustomerSlice,
  getAllRejectedCustomersWithCreatorAndRejector: getAllRejectedCustomersWithCreatorAndRejectorSlice,
  getAllReapprovalCustomersWithCreatorAndRejector: getAllReapprovalCustomersWithCreatorAndRejectorSlice,
  getAllHomeSectionsBySectionName: getAllHomeSectionsBySectionNameSlice,
  rejectHomeSection: rejectHomeSectionSlice,
  approveHomeSection: approveHomeSectionSlice,
  approveStakeNowSection: approveStakeNowSectionSlice,
  rejectStakeNowSection: rejectStakeNowSectionSlice,
  approveReferralSection:approveReferralSectionSlice,
  rejectReferralSection:rejectReferralSectionSlice,

  rejectAboutUsSection:rejectAboutUsSectionSlice,

  approveAboutUsSection:approveAboutUsSectionSlice,
  approveBlogSection:approveBlogSectionSlice,
  rejectBlogSection:rejectBlogSectionSlice,
  rejectContactUsSection:rejectContactUsSectionSlice,
  approveContactUsSection:approveContactUsSectionSlice,
  getAllPendingPlansWithCreator:getAllPendingPlansWithCreatorSlice,
  getAllApprovedPlansWithCreatorAndApprover:getAllApprovedPlansWithCreatorAndApproverSlice,

  getAllRejectedPlansWithCreatorAndRejector:getAllRejectedPlansWithCreatorAndRejectorSlice,
  getAllReapprovalPlansWithCreatorAndRejector:getAllReapprovalPlansWithCreatorAndRejectorSlice,
  approvePlan:approvePlanSlice,
  rejectPlan:rejectPlanSlice,
  getAllPendingPurchasesWithCreator:getAllPendingPurchasesWithCreatorSlice,
  getAllApprovedPurchasesWithCreatorAndApprover:getAllApprovedPurchasesWithCreatorAndApproverSlice,
  approvePurchase:approvePurchaseSlice,
  getAllActiveTiers:getAllActiveTiersSlice,
  getAllCountriesWithDetails:getAllCountriesWithDetailsSlice,
  getCountryWithDetailsById:getCountryWithDetailsByIdSlice,
  addPlanWithApproval:addPlanWithApprovalSlice,
  updatePlanForReApproval:updatePlanForReApprovalSlice,
  getAllPlansWithCreator:getAllPlansWithCreatorSlice,
  getAllPlansBasedOnCreator:getAllPlansBasedOnCreatorSlice,
  getManagementDashboardData:getManagementDashboardDataSlice,




});

const store = configureStore({
  reducer,
});
export default store;
